// Copyright (c) 2017 PlanGrid, Inc.

import React from 'react';
import { PDFJS } from 'pdfjs-dist/build/pdf.combined';
import 'pdfjs-dist/web/compatibility';
import generate from 'shortid';
import PropTypes from 'prop-types';

import { PDFPage } from './PDFPage';

PDFJS.disableWorker = true;
const INCREASE_PERCENTAGE = 0.2;

export default class PDFDriver extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pdf: null,
      zoom: 0,
    };

    this.increaseZoom = this.increaseZoom.bind(this);
    this.reduceZoom = this.reduceZoom.bind(this);
    this.resetZoom = this.resetZoom.bind(this);
  }

  componentDidMount() {
    const { filePath } = this.props;
    const containerWidth = this.container.offsetWidth;
    PDFJS.getDocument(filePath, null, null, null).then((pdf) => {
      this.setState({ pdf, containerWidth });
    });
  }

  setZoom(zoom) {
    this.setState({
      zoom,
    });
  }

  reduceZoom() {
    if (this.state.zoom === 0) return;
    this.setZoom(this.state.zoom - 1);
  }

  increaseZoom() {
    this.setZoom(this.state.zoom + 1);
  }

  resetZoom() {
    this.setZoom(0);
  }

  renderPages() {
    const { pdf, containerWidth, zoom } = this.state;
    if (!pdf) return null;
    const pages = Array(...{ length: pdf.numPages });
    return pages.map((v, i) => (
      (<PDFPage
        index={i + 1}
        key={generate()}
        pdf={pdf}
        containerWidth={containerWidth}
        zoom={zoom * INCREASE_PERCENTAGE}
        disableVisibilityCheck={this.props.disableVisibilityCheck}
      />)
    ));
  }

  renderLoading() {
    if (this.state.pdf) return null;
    return (<this.props.loadingComponent />);
  }

  render() {
    return (
      <div className="d-flex h-100 w-100">
        <div
          className="w-100"
          ref={(node) => {
          this.container = node;
          return node;
          }}
        >
          <div className="pdf-controlls-container">
            <div
              role="button"
              tabIndex={0}
              className="view-control"
              onClick={this.increaseZoom}
              onKeyPress={(event) => {
                 if (event.key === 'Enter' || event.key === ' ') this.increaseZoom();
                 }}
            >
              <i className="zoom-in" />
            </div>
            <div
              role="button"
              tabIndex={0}
              className="view-control"
              onClick={this.resetZoom}
              onKeyPress={(event) => { if (event.key === 'Enter' || event.key === ' ') this.resetZoom(); }}
            >
              <i className="zoom-reset" />
            </div>
            <div
              role="button"
              tabIndex={0}
              className="view-control"
              onClick={this.reduceZoom}
              onKeyPress={(event) => { if (event.key === 'Enter' || event.key === ' ') this.reduceZoom(); }}
            >
              <i className="zoom-out" />
            </div>
          </div>
          {this.renderLoading()}
          {this.renderPages()}
        </div>
      </div>
    );
  }
}

PDFDriver.propTypes = {
  filePath: PropTypes.string.isRequired,
  disableVisibilityCheck: PropTypes.bool,
};

PDFDriver.defaultProps = {
  disableVisibilityCheck: false,
};



// WEBPACK FOOTER //
// ./src/components/FileViewer/drivers/pdf-viewer.jsx